export const shipmentStatus = {
  SHIPPED: 'Shipped'
}

export const orderStatus = {
  PAID: 'Paid',
  CANCELED: 'Canceled',
  REFUNDED: 'Refunded',
  PARTIALLY_PAID: 'Partially paid',
  AWAITING_PAYMENT: 'Awaiting payment',
  PARTIALLY_REFUNDED: 'Partially refunded',
  DECLINED: 'Declined'
}
